<div class="UserManagement">
   <div class="Loading" *ngIf="isShowLoading==true">
      <img id="" src="assets/img/762.gif" />
   </div>
   <div class="DoctorDetailsSection">
      <div class="panel panel-default panel-table">
         <div class="panel-heading">
            <div class="row">
               <div class="col col-xs-6">
                  <h3 class="panel-title">{{'Profile'|translate}}</h3>
               </div>
               <div class="col col-xs-6 text-right">
               </div>
            </div>
         </div>
         <div class="panel-body">
            <div class="">
               <div class="Grdi">
                  <div class="row">
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="ProfilePage">
                           <div class="row">
                              <span class="titledis">
                                 <!-- Manage this basic information — your name, email, and phone number — to help others find you on ACIG products like Motor Insurace, Travel Insurance, and Medmal, and make it easier to get in touch.-->
                              </span>
                           </div>
                           <div class="ChangePasswordForm">
                              <div class="row">
                                 <div class="col-lg-1 col-md-1 hidden-sm hidden-xs"></div>
                                 <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                    <div class="profileform">
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Full Name'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{profileObj.InsuredName}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'EmailID'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{profileObj.EmailID}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i (click)="Emailmodal()" class="glyphicon glyphicon-edit"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'ID Number'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{profileObj.IqamaNo}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Mobile Number'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">966 {{profileObj.MobileNo}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i class="glyphicon glyphicon-edit" (click)="Mobilemodal()"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <!-- <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Nationality'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{Lng=="en"?NatEn:NatAr}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"
                                                [hidden]="true"></span>
                                          </div>
                                       </div> -->
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'IBAN Number'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{profileObj.IBAN}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i class="glyphicon glyphicon-edit" (click)="IBANmodal()"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Language'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">{{profileObj.Language}}</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i class="glyphicon glyphicon-edit" (click)="Langmodal()"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset" *ngIf="false">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Address'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">-</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Password'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData">******</span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i class="glyphicon glyphicon-edit" (click)="Passwordmodal()"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2" [hidden]="true">
                                             <span class="glyphicon glyphicon-chevron-right iconDisplay"></span>
                                          </div>
                                       </div>
                                       <div class="row rowset">
                                          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                             <span class="lbldisplay">{{'Address'|translate}}</span>
                                          </div>
                                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                             <span class="lblData"></span>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                             <i class="glyphicon glyphicon-edit" (click)="Addressmodal()"></i>
                                          </div>
                                          <div class="col-lg-2 col-md-2">
                                            
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-lg-1 col-md-1 hidden-sm hidden-xs"></div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal" id="UpdateProfile" role="dialog" [ngClass]="{'fade in':EmailAddressmodal}">
   <div class="modal-dialog modal-md">
      <div class="modal-content">
         <div class="modal-header">
            <button type="button" class="close" (click)="closemodal()">&times;</button>
            <h4 class="modal-title">{{'Update Profile'|translate}}</h4>
         </div>
         <div class="modal-body">
            <div class="UpdateProfileForm">
               <form #UpdateProfileForm="ngForm" oncontextmenu="return false" oncopy="return false"
                  onpaste="return false" oncut="return false">
                  <div class="row updateemailfeild">
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 newfeilds">
                        <label class="lbltext lblEmailId">{{'Email Address'|translate}}</label>
                     </div>
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <input type="text" class="form-control newemail" id="Email" name="txtEmail"
                           [(ngModel)]="profileReq.EmailID" #txtEmail="ngModel" required autocomplete="off"
                           pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?!\.)(?!.*?\.\.)(?!.*\.$)[a-zA-Z.]{2,10}$"
                           placeholder="{{'Enter Email ID'|translate}}" />
                        <span *ngIf="txtEmail.invalid && (txtEmail.dirty)" class="text-danger valid">
                           <div *ngIf="txtEmail.errors.required">
                              {{'EmailId is required'|translate}}
                           </div>
                           <div *ngIf="txtEmail.errors.pattern">
                              {{'Invalid Email Format'|translate}}
                           </div>
                        </span>
                     </div>
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 buttonsclass">
                        <div class="updatebtn">
                           <button type="button" name="Update Profile" id="Update"
                              class="btn btn-primary btns modalbtns" [disabled]="!UpdateProfileForm.valid"
                              (click)="UpdateEmail(UpdateProfileForm.valid)">{{'Update'|translate}}</button>
                        </div>
                     </div>
                  </div>
                  <div class="row OTPForm" *ngIf="IsShowOTPBlock">
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 newfeilds">
                        <label class="Verifi">{{'Verification Code'|translate}}</label>
                     </div>
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 otpinput">
                        <input type="text" class="form-control otpinp" maxlength="6" id="txtEmailOTP" name="txtEmailOTP"
                           [(ngModel)]="EmailOTP" #txtEmailOTP="ngModel" required autocomplete="off">
                     </div>
                     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 buttonsclass">
                        <div class="otpbtn">
                           <button type="button" class="btn btn-primary Resend modalbtns"
                              (click)="verifyEmailOTP()">{{'Verify'|translate}}</button>
                           <button type="button" class="btn btn-primary Resend modalbtns" *ngIf="isResendShowEmail"
                              (click)="ResendEmailOTP()">{{'Resend'|translate}}</button>
                        </div>
                     </div>
                  </div>
                  <div class="row otptimerdiv" *ngIf="ShowEmailTimer">
                     <span class="otptimerspan" *ngIf="timeLeft != 0">You can resend OTP in {{timeLeft}} seconds</span>
                     <span class="otptimerspan" *ngIf="timeLeft == 0">Click on Resend button</span>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal" id="UpdateMobile" role="dialog" [ngClass]="{'fade in':MobileUpdatemodal}">
   <div class="modal-dialog modal-md">
      <div class="modal-content">
         <div class="modal-header">
            <button type="button" class="close" (click)="closeMobilemodal()">&times;</button>
            <h4 class="modal-title">{{'Update Profile'|translate}}</h4>
         </div>
         <div class="modal-body">
            <div class="UpdateMobileForm">
               <form #UpdateMobileForm="ngForm" oncontextmenu="return false" oncopy="return false"
                  onpaste="return false" oncut="return false">
                  <div class="row">
                     <div class="Field">
                        <div class="col-lg-8 col-md-4 col-sm-6 col-xs-12">
                           <label class="lbltext lblMobile">{{'Mobile Number'|translate}}</label>
                           <input type="text" id="txtMobile" (change)="YakeenMobileNoVerify()" numbersOnly required maxlength=9 minlength="9"
                              name="txtMobile" pattern="^5\d{8}$" [(ngModel)]="profileReq.MobileNo"
                              class="form-control Mobiles" #txtMobile="ngModel" placeholder="5XXXXXXXX">
                           <span *ngIf="txtMobile.errors && (txtMobile.dirty || txtMobile.touched)"
                              class="text-danger valid">
                              <p *ngIf="txtMobile.errors.required">{{'Mobile No is required'|translate}}</p>
                              <p *ngIf="txtMobile.errors.pattern && txtMobile.invalid && txtMobile.touched ">
                                 {{'Mobile Number must be like (5XXXXXXXX)'|translate}} </p>
                           </span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                           <div class="ButtonSections">
                              <button type="button" name="Update Mobile" id="Update Mobile"
                                 class="btn btn-primary Resend"
                                 [disabled]="!UpdateMobileForm.valid || DisableMobileUpdate==false"
                                 (click)="UpdateMobile(UpdateMobileForm.valid)">{{'Update'|translate}}</button>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="row">
                     <div class="OTPForm" *ngIf="showOTP">
                        <div class="Field">
                           <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                              <label class="Verifi lbltext">{{'Verification Code'|translate}}</label>
                              <input type="text" id="txtOTP" name="txtOTP" [(ngModel)]="otpReq.OTP"
                                 class="form-control">
                           </div>
                           <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                              <div class="ButtonSections">
                                 <button type="button" class="btn btn-primary Resend" (click)="ResendOTP()"
                                    *ngIf="isResendShow">{{'Resend'|translate}}</button>
                                 <button type="button" class="btn btn-primary Resend" (click)="verifyOTP()"
                                    *ngIf="ShowVerify">{{'Verify'|translate}}</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="Field" *ngIf="this.isShowTimer">
                     <span class="quotelink">{{'OTP will expire in'|translate}} {{ this.CurrentTime }}
                        {{'Seconds'|translate}}</span>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal" id="UpdateIBAN" role="dialog" [ngClass]="{'fade in':IBANUPDATEmodal}">
   <div class="modal-dialog modal-md">
      <div class="modal-content">
         <div class="modal-header">
            <button type="button" class="close" (click)="closeIBANmodal()">&times;</button>
            <h4 class="modal-title">{{'Update Profile'|translate}}</h4>
         </div>
         <div class="modal-body">
            <div class="UpdateIBANForm">
               <form #UpdateIBANForm="ngForm" oncontextmenu="return false" oncopy="return false" onpaste="return false"
                  oncut="return false">
                  <div>
                     <div class="col-md-12 iban">
                        <div class="row">
                           <div class="col-lg-12 col-sm-12 col-xs-12  col-md-12">
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                 <label class="lbltext">{{'IBAN Number'| translate }}</label>
                                 <div class="row">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <div class="input-group groupItems">
                                          <div class="input-group-addon" style="padding: 3px 4px;">SA</div>
                                          <input type="text" class="form-control" id="txtIBAN1" name="txtIBAN1"
                                             [(ngModel)]="IBAN1" maxlength="2" #txtIBAN1
                                             [value]="txtIBAN1.value.toUpperCase()"
                                             (ngModelChange)="iban1Changed($event)" required autocomplete="off"
                                             style="padding: 4PX;" />
                                       </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <input type="text" class="form-control" id="txtIBAN2" name="txtIBAN2"
                                          [(ngModel)]="IBAN2" maxlength="4" [disabled]="IBAN1?.length!=2" #txtIBAN2
                                          [value]="txtIBAN2.value.toUpperCase()" (ngModelChange)="iban2Changed($event)"
                                          numbersOnly required autocomplete="off" />
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <input type="text" class="form-control" id="txtIBAN3" name="txtIBAN3"
                                          [(ngModel)]="IBAN3" maxlength="4" [disabled]="IBAN2?.length!=4" #txtIBAN3
                                          [value]="txtIBAN3.value.toUpperCase()" (ngModelChange)="iban3Changed($event)"
                                          numbersOnly required autocomplete="off" />
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <input type="text" class="form-control" id="txtIBAN4" name="txtIBAN4"
                                          [(ngModel)]="IBAN4" maxlength="4" [disabled]="IBAN3?.length!=4" #txtIBAN4
                                          [value]="txtIBAN4.value.toUpperCase()" (ngModelChange)="iban4Changed($event)"
                                          numbersOnly required autocomplete="off" />
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <input type="text" class="form-control" id="txtIBAN5" name="txtIBAN5"
                                          [(ngModel)]="IBAN5" maxlength="4" [disabled]="IBAN4?.length!=4" #txtIBAN5
                                          [value]="txtIBAN5.value.toUpperCase()" (ngModelChange)="iban5Changed($event)"
                                          numbersOnly required autocomplete="off" />
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                       <input type="text" class="form-control" id="txtIBAN6" name="txtIBAN6"
                                          [(ngModel)]="IBAN6" maxlength="4" [disabled]="IBAN5?.length!=4" #txtIBAN6
                                          [value]="txtIBAN6.value.toUpperCase()" numbersOnly required
                                          autocomplete="off" />
                                    </div>
                                    <span class="instruct text-danger valid">*{{'IBAN Number must start with SA and enter 4 letters in each textbox(Ex:SA12 8056 7890 1234 6575 9898)'|translate}}</span>
                                 </div>
                                 <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 banknamebind">
                                       <label class="lbltext banknamelabel">{{'Bank Holder Name'| translate }}</label>
                                       <input class="form-control" (keypress)="allowEnglishOnly($event)" id="txtAccHolderName" name="txtAccHolderName"
                                          [(ngModel)]="profileObj.AccountName" type="text">
                                       <small style="color: red; font-size: 12px;">
                                          {{'NOTE: Name should contain English letters only'| translate }}
                                       </small>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div>
                     <div class="col-lg-8 col-md-4 col-sm-6 col-xs-12">
                        <label class="lbl"></label>
                        <input type="text" [hidden]="true" />
                     </div>
                  </div>
                  <div class="Actionsection">
                     <div class="Actions">
                        <div class="btn-group">
                           <button type="button" name="Update Profile" id="Update" class="btn btn-primary btns"
                              [disabled]="!UpdateIBANForm.valid" (click)="UpdateIBAN()">{{'Update'|translate}}</button>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal" id="UpdateLang" role="dialog" [ngClass]="{'fade in':LangUpdatemodal}">
   <div class="modal-dialog modal-md">
      <div class="modal-content">
         <div class="modal-header">
            <button type="button" class="close" (click)="CloseLangmodal()">&times;</button>
            <h4 class="modal-title">{{'Update Profile'|translate}}</h4>
         </div>
         <div class="modal-body">
            <div class="UpdateProfileLangForm">
               <form #UpdateProfileLangForm="ngForm" oncontextmenu="return false" oncopy="return false"
                  onpaste="return false" oncut="return false">
                  <div class="Field">
                     <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                        <label class="lblLang lbltext">{{'Language'|translate}}</label>
                        <select class="form-control" id="txtLan" name="txtLan" required
                           [(ngModel)]="profileReq.Language" #txtLan="ngModel" autocomplete="off">
                           <option value="">--{{'Select Language'|translate}}--</option>
                           <option value="en">{{'English'| translate }}</option>
                           <option value="ar">{{'Arabic'| translate }}</option>
                        </select>
                        <span *ngIf="txtLan.invalid && (txtLan.dirty  || txtLan.touched)" class="text-danger">
                           <div *ngIf="txtLan.errors.required">
                              {{'Language is required'|translate}}
                           </div>
                        </span>
                     </div>
                     <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div class="ButtonSections">
                           <button type="button" name="Update Profile" id="Update" class="btn btn-primary btns"
                              [disabled]="!UpdateProfileLangForm.valid"
                              (click)="UpdateLang()">{{'Update'|translate}}</button>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="modal" id="UpdatePassword" role="dialog" [ngClass]="{'fade in':PasswordUpdatemodal}">
   <div class="modal-dialog modal-md">
      <div class="modal-content">
         <div class="modal-header">
            <button type="button" class="close" (click)="ClosePasswordmodal()">&times;</button>
            <h4 class="modal-title">{{'Change Password'|translate}}</h4>
         </div>
         <div class="modal-body">
            <div class="UpdatePasswordForm">
               <form #UpdatePasswordForm="ngForm" oncontextmenu="return false" oncopy="return false"
                  onpaste="return false" oncut="return false">
                  <div class="Field">
                     <div class="col-lg-8 col-md-4 col-sm-6 col-xs-12">
                        <label class="lbltext lblOldpwd">{{'Old Password'|translate}}</label>
                        <input type="password" class="form-control" id="txtoldPwd" name="txtoldPwd"
                           [(ngModel)]="profileReq.Password" #txtoldPwd="ngModel" required autocomplete="off"
                           placeholder="{{'Enter Old Password'|translate}}" />
                        <span *ngIf="txtoldPwd.invalid && (txtoldPwd.dirty)" class="text-danger valid">
                           <div *ngIf="txtoldPwd.errors.required">
                              {{'Old Password is required'|translate}}
                           </div>
                        </span>
                     </div>
                  </div>
                  <div class="Field">
                     <div class="col-lg-8 col-md-4 col-sm-6 col-xs-12">
                        <label class="lbltext lblOldpwd">{{'New Password'|translate}}</label>
                        <input type="password" class="form-control" id="txtNewPwd" name="txtNewPwd"
                           [(ngModel)]="profileReq.NewPassword" #txtNewPwd="ngModel" maxlength="20"
                           pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" required
                           autocomplete="off" placeholder="{{'Enter New Password'|translate}}"
                           (ngModelChange)="CheckPass()" />
                        <span *ngIf="txtNewPwd.invalid && (txtNewPwd.dirty )" class="text-danger valid">
                           <div *ngIf="txtNewPwd.errors.required">
                              {{'New Password is required'|translate}}
                           </div>
                           <div *ngIf="txtNewPwd.errors?.maxlength">
                              {{'New Password should be maximum 20 Characters'| translate }}
                           </div>
                           <div *ngIf="txtNewPwd.errors?.pattern">
                              {{'Password must contains Alphanumeric, uppercase, lowercase and special characters and minimum length is 8 digits'| translate }}
                           </div>
                        </span>
                     </div>
                  </div>
                  <div class="Field">
                     <div class="col-lg-8 col-md-4 col-sm-6 col-xs-12">
                        <label class="lbltext lblOldpwd">{{'Re-enter Password'|translate}}</label>
                        <input type="password" class="form-control" id="txtConPwd" name="txtConPwd"
                           [(ngModel)]="profileReq.ConfirmPassword" #txtConPwd="ngModel" maxlength="20" minlength="8"
                           (ngModelChange)="Check()" required autocomplete="off"
                           placeholder="{{'Enter Confirm Password'|translate}}" />
                        <span *ngIf="txtConPwd.invalid && (txtConPwd.dirty )" class="text-danger valid">

                           <div *ngIf="txtConPwd.errors.required">
                              {{'Confirm Password is required'|translate}}
                           </div>
                           <div *ngIf="txtConPwd.errors?.maxlength">
                              {{'Confirm should be 6 Characters'| translate }}
                           </div>
                           <div *ngIf="txtConPwd.errors?.minlength">
                              {{'Confirm should be 6 Characters'| translate }}
                           </div>
                        </span>
                        <span>
                           <div *ngIf="!PasswordMatched" class="text-danger valid">
                              {{'Password Mismatch'|translate}}
                           </div>
                        </span>
                     </div>
                  </div>
                  <div class="Field">
                     <div class="col-lg-4 col-md-4 col-xs-12 col-sm-12">
                        <div class="ButtonSections">
                           <button type="button" name="Changepwd" id="Changepwd" class="btn btn-primary btns"
                              [disabled]="!UpdatePasswordForm.valid || !PasswordMatched"
                              (click)="UpdatePwd(UpdatePasswordForm.valid)">{{'Update'|translate}}</button>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>



<div class="modal" id="AddressUpdate" role="dialog"  [ngClass]="{'fade in':AddressUpdatemodal}">
      <div class="modal-dialog modal-md AddresUpdateMdl">
         <div class="modal-content">
            <div class="modal-header">
               <button type="button" class="close" (click)="CloseAddressmodal()">&times;</button>
               <h4 class="modal-title">{{'Address'|translate}}</h4>
            </div>
            <div class="modal-body">
               <div class="UpdateAddressForm">
                  <form #UpdateAddressForm="ngForm" oncontextmenu="return false" oncopy="return false"
                     onpaste="return false" oncut="return false">
                     <div class="Field">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                           <label class=" lbltext">{{'Building No'|translate}}</label>
                           <input disabled=true type="text" id="txtBuildingNo" required  name="txtBuildingNo"  class="form-control" placeholder="{{profileObj.BuildingNo}}">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class=" lbltext">{{'Street'|translate}}</label>
                              <input disabled=true type="text" id="txtStreet" required  name="txtStreet"  class="form-control" placeholder="{{profileObj.Street}}">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class=" lbltext">{{'District'|translate}}</label>
                              <input disabled=true type="text" id="txtDistrict" required  name="txtDistrict"  class="form-control" placeholder="{{profileObj.District}}">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class=" lbltext">{{'City'|translate}}</label>
                              <input disabled=true type="text" id="txtCity" required  name="txtCity"  class="form-control" placeholder="{{profileObj.City}}">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class=" lbltext">{{'PostalCode'|translate}}</label>
                              <input disabled=true type="text" id="txtPostalCode" required  name="txtPostalCode"  class="form-control" placeholder="{{profileObj.PostalCode}}">
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class=" lbltext">{{'AdditionalNo'|translate}}</label>
                              <input disabled=true type="text" id="txtAdditionalNo" required  name="txtAdditionalNo"  class="form-control" placeholder="{{profileObj.AdditionalNo}}">
                        </div>
                        <div class="col-lg-12 col-sm-12 col-xs-12 text-center">
                           <div class="ButtonSections">
                              <button type="button" name="Update Address" id="" class="btn btn-primary btns"
                              [disabled]="!UpdateAddressForm.valid" (click)="UpdateAddress()">{{'Get Address From Saudipost And Update'|translate}}</button>
                           </div>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Profile/Profile.html